export function openURL({
  url,
  openInNewWindow
}) {
  if (openInNewWindow) {
    window.open(url, '_blank', 'noopener');
  } else {
    window.location.href = url;
  }
}